export const environment = {
  appVersion: require("../../../../package.json").version,
  production: true,
  apiUrl: "https://app.assistonline.eu/api/",
  loginUrl: "https://app.assistonline.eu/externalLogin/Login.aspx",
  imageUrl: "https://app.assistonline.eu",
  publicApiUrl: "https://publicapi.assistonline.eu/",
  authenticationServer: "https://account.assistonline.eu/",
  mijnUrl: "https://nieuw.mijnassist.eu",
  appKey: "D7E5D684-B5E5-492B-A4FE-337A4E3C6C5E",
  unsplashAccessKey: "wjcozG9L8tyVN7LbfaeVpqAO0ZvfWwaY1t682QBTFLk",
  pexelsApiKey: "9VD1utzwLpKj43W0Ka7gWByTxD8xddvz66mvwS6JHi1pC2MfaYBbjVJo",
  googleAnalyticsId: "", // Add your GA4 measurement ID here for test
  beaconId: "75008245-5a38-4cf6-9bbe-9e7df61aadd5",
  beaconEnabled: true,
};
